/* eslint-disable no-restricted-syntax */
const accountRoutes = Object.freeze({
  ACCOUNT_FISH: 'account-fish',
  CREATE_ROUTE_FISH: 'fish-route-create',
  LOGIN_FISH: 'login-fish',
  SETTINGS_FISH: 'settings-fish',
  APP_FEEDBACK_FISH: 'app-feedback-fish',
  CREATE_ACCOUNT_FISH: 'create-account-fish',
})

const queryRoutes = Object.freeze({
  QUERY_FISH: 'query-fish',
  QUERY_FISH_OVERVIEW: 'query-fish-overview',
  QUERY_FISH_WEATHER: 'query-fish-weather',
})

const mapUtilsRoutes = Object.freeze({
  FISH_MAP: 'fish-map',
  OFFLINE_FISH: 'offline-fish',
})

const waterbodyRoutes = Object.freeze({
  WATER: 'water',
  WATERBODIES: 'waterbodies',
  WATERBODIES_GROUP: 'waterbodies-group',
  WATERBODY: 'waterbody',
  WATERBODY_REGION: 'waterbody-region',
  WATERBODY_OVERVIEW: 'waterbody-overview',
  WATERBODY_WEATHER: 'waterbody-weather',
  WATERBODIES_FILTER: 'waterbodies-filter',
  WATERBODY_NEARBY: 'waterbodies-nearby',
  FISH_SPECIES: 'fish-species',
  FISH_SPECIES_INFO: 'fish-species-info',
  FISH_SPECIES_ABUNDANCE_INFO: 'fish-species-abundance',
  FISH_SPECIES_STOCKING_INFO: 'fish-species-stocking',
  REGIONS_TAB: 'regions-tab',
  FISHING_REPORTS: 'fishing-reports',
  FISHING_REPORTS_LIST: 'fishing-reports-list',
})

const waterAccessRoutes = Object.freeze({
  WATER_ACCESS: 'water-access',
  WATER_ACCESS_SITE: 'water-access-site',
  WATER_ACCESS_SITE_OVERVIEW: 'water-access-site-overview',
  WATER_ACCESS_WEATHER: 'water-access-weather',
})

const weatherRoutes = Object.freeze({
  WEATHER_OVERVIEW_FISH: 'weather-overview-fish',
  WEEKLY_WEATHER_FISH: 'weather-weekly-forecast-fish',
  HOURLY_WEATHER_FISH: 'weather-hourly-forecast-fish',
  MOON_WEATHER_FISH: 'weather-moon-forecast-fish',
})

const contentRoutes = Object.freeze({
  MANAGE_ACCESS_FISH: 'manage-access-fish',
  MY_CONTENT_CARD_FISH: 'my-content-card-fish',
  MY_CONTENT_CREATED_FISH: 'fish-my-content-created',
  FAVORITES_FISH: 'fish-my-content-saved',
  FAVORITE_LAKES: 'favorite-lakes-fish',
  FAVORITE_WATER_ACCESS: 'favorite-water-access-fish',
  FAVORITE_FISHING_AREA: 'favorite-fishing-area',
})

const fishingAreaRoutes = Object.freeze({
  FISHING_AREA_CARD: 'fishing-area-card',
  FISHING_AREA: 'fishing-area',
  FISHING_AREA_SPECIES: 'fishing-area-species',
  POLYGON: 'polygon',
  POLYGON_OVERVIEW: 'polygon-overview',
})

const regionsRoutes = Object.freeze({
  FISHERY_INFO: 'fishery-info',
  FISHERY_SPECIES_TIPS: 'fishery-species-tips',
  REGION: 'region',
  REGION_OVERVIEW: 'region-overview',
  REGION_WATERBODY_OVERVIEW: 'region-waterbody-overview',
  REGION_WEATHER: 'region-weather',
  REGION_WATERBODY_WEATHER: 'region-waterbody-weather',
  SUB_REGION: 'sub-region',
  REGION_WATERBODY_SPECIES: 'region-waterbody-species',
})

const fishRoutes = Object.freeze({
  ...accountRoutes,
  ...queryRoutes,
  ...mapUtilsRoutes,
  ...waterbodyRoutes,
  ...weatherRoutes,
  ...waterAccessRoutes,
  ...contentRoutes,
  ...fishingAreaRoutes,
  ...regionsRoutes,
})

export default fishRoutes
